// extracted by mini-css-extract-plugin
export default {"btn":"ButtonComponent_btn__QqjIk","btnDisabled":"ButtonComponent_btnDisabled__okILB"};